//툴팁 열기
function addAciveClass(e) {
  e.target.classList.toggle('active')
}
export { addAciveClass }
